// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f1733529","453":"3185a37c","455":"15f48521","977":"5941e294"}[chunkId] + ".chunk.js";
};